import { createSlice } from "@reduxjs/toolkit";
import { openModal } from "../modal/modalSlice";
import { calculateConnectedTotalLoad, disconnect } from "../load/loadSlice";

const controlPanelSlice = createSlice({
    name: 'controlPanel',
    initialState: {
        mode: 'normal',
        connectedGeneratedPower: 0 
    },
    reducers:{
        setMode:  (state, action) => {
            state.mode = action.payload
        },
        setConnectedGeneratedPower: (state, action) => {
            state.connectedGeneratedPower = action.payload
        }
    },
})

export function calculateConnectedGeneratedPower(){
    // sum up generated power from solar and hydro source
    // To enable comparison between connected generated power
    // versus connected load to avoid overloading.
    return (dispatch, getState) => {
        
        let connectedGeneratedPower = 0
        let hydroSource = getState().hydroSource
        let solarSource = getState().solarSource
        connectedGeneratedPower += hydroSource.isRunning? hydroSource.powerGenerated: 0
        connectedGeneratedPower += solarSource.isRunning? solarSource.powerGenerated: 0  
        dispatch(setConnectedGeneratedPower(connectedGeneratedPower))      
    }
}

export function controlLoads(loadId){
    return (dispatch, getState) => {
        let disconnectedLoads = []
        let loads = getState().load.loadItems
        let body = ''
        // update sum of connected power sources
        dispatch(calculateConnectedGeneratedPower())
        let connectedGeneratedPower = getState().controlPanel.connectedGeneratedPower
        // total connected loads
        let totalConnectedLoads = getState().load.totalConnectedLoad 
        connectedGeneratedPower = connectedGeneratedPower * 1000
        if(connectedGeneratedPower < totalConnectedLoads){
            if(loadId === 0){
                // diconnect all loads in case no ID is passed
                let total = totalConnectedLoads

                // reverse the load items so that tertiary load
                // so that the loop starts with tertiary load
                loads.forEach((load, index) => {
                    // disconnect load starting from tertiary load
                    // till the total load is less than the total generated power
                    let loadItem = loads[loads.length - index - 1]
                    
                    // console.log('total:', total, connectedGeneratedPower)
                    console.log(total > connectedGeneratedPower)
                    if(total > connectedGeneratedPower){
                        // diconnect load with an ID
                        dispatch(disconnect(loadItem.id))
                        disconnectedLoads.push(loadItem)
                        dispatch(calculateConnectedTotalLoad())
                        total = total - loadItem.consumption
                    }
                });
                
                if(disconnectedLoads.length > 1){
                    let names = disconnectedLoads.map(load => load.name)
                    names = names.join(', ')
                    body = `${names} loads were disconnected to avoid overload. Ensure sources are connected first`
                }else if (disconnectedLoads.length === 1){
                    body = `${disconnectedLoads[0].name} load was disconnected to avoid overload. Ensure sources are connected first`
                }
            }else{
                // when an Id is passed
                dispatch(disconnect(loadId))
                disconnectedLoads = loads.find(load => load.id === loadId)
                body = `${disconnectedLoads[0].name} load was disconnected to avoid overload. Ensure sources are connected first`
            }

            // get disconnected load names
            dispatch(openModal(
                    {
                        title: 'Overload error', 
                        body
                    }
                )
            )

        }
    }
}

export const {setMode, setConnectedGeneratedPower} = controlPanelSlice.actions
export default controlPanelSlice.reducer